import { Component, ElementRef, OnInit } from '@angular/core';

import { UrlsService } from 'Angular/services/core/urls.service';
import { CookieService } from 'ngx-cookie-service';

/**
 * Password Reset Component
 *
 * Required Attributes:
 *    @ actionUrl: URL for the form submit action
 */

interface PasswordResetFormData {
    newPassword1: string;
    newPassword2: string;
}

@Component({ standalone: false, selector: 'ycn-password-reset', templateUrl: './password-reset.template.html' })
export class PasswordResetComponent implements OnInit {
    actionUrl: string = '';

    csrfToken: string = '';

    form: PasswordResetFormData = {
        newPassword1: '',
        newPassword2: '',
    };

    contactRedirectUrl = this.urlsService.SUPPORT.CONTACT_REDIRECT;

    constructor(private cookieService: CookieService, private urlsService: UrlsService, el: ElementRef) {
        this.form.newPassword1 = el.nativeElement.getAttribute('new_password1') || '';
        this.form.newPassword2 = el.nativeElement.getAttribute('new_password2') || '';

        this.actionUrl = el.nativeElement.getAttribute('actionUrl');
    }

    ngOnInit(): void {
        this.csrfToken = this.cookieService.get('csrftoken');
    }
}
